/**
 * Utility functions for blur filter management
 */

/**
 * Convert blur level to Twilio's blurFilterRadius
 * @param blurLevel - The blur level (1-3)
 * @returns The corresponding blur filter radius
 */
export function getBlurFilterRadius(blurLevel: number): number {
	const blurLevelMap: Record<number, number> = {
		1: 5, // Light blur
		2: 12, // Medium blur
		3: 15 // High blur
	}
	return blurLevelMap[blurLevel] || 15
}
